import { render, staticRenderFns } from "./FiltrosDocumentos.vue?vue&type=template&id=584ea883"
import script from "./FiltrosDocumentos.vue?vue&type=script&lang=js"
export * from "./FiltrosDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports